import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bonusomat-board-rules" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { StringUtils } from "@sazka/utils/string-utils";
import { computed } from "vue";
import MobileAppLink from "@sazka/mobile-apps/components/mobile-app-link.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-board-rules',
  props: {
    minBetAmount: {},
    rulesLik: {}
  },
  setup(__props: any) {

const props = __props;

const minBetAmountFormated = computed(() => StringUtils.formatCurrency(props.minBetAmount));
const minBetAmountLiveGamesFormated = StringUtils.formatCurrency(10);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createTextVNode(" Minimální sázka u všech úkolů je ")),
    _createElementVNode("span", {
      class: "bonusomat-board-rules__amount",
      innerHTML: minBetAmountFormated.value
    }, null, 8, _hoisted_2),
    _cache[2] || (_cache[2] = _createTextVNode(", s výjimkou úkolu Hry Live, kde činí ")),
    _createElementVNode("span", {
      class: "bonusomat-board-rules__amount",
      innerHTML: _unref(minBetAmountLiveGamesFormated)
    }, null, 8, _hoisted_3),
    _cache[3] || (_cache[3] = _createTextVNode(". ")),
    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
    _cache[5] || (_cache[5] = _createTextVNode(" Kompletní pravidla ")),
    _createVNode(MobileAppLink, {
      href: _ctx.rulesLik,
      "event-name": "openPdf",
      "event-argument": _ctx.rulesLik,
      "open-in-new-tab": true,
      class: "bonusomat-board-rules__link"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("zde")
      ])),
      _: 1,
      __: [0]
    }, 8, ["href", "event-argument"]),
    _cache[6] || (_cache[6] = _createTextVNode(". "))
  ]))
}
}

})